<template>
  <div
    class="is-flex is-align-items-center is-justify-content-space-between is-full-height px-3"
    :data-e2e="TimeEntryCypressAttribute.views.TIME_ENTRY_ROW"
  >
    <div class="is-flex is-align-items-center">
      <i class="cls cls-calendar is-size-6 p-r-5" />
      <p
        class="is-size-6 has-text-grey"
        :data-e2e="TimeEntryCypressAttribute.views.TIME_ENTRY_ROW_DATE"
      >
        {{ timeEntry.formattedStartedAt }}
      </p>
      <Status
        v-if="status"
        class="m-t--3 mx-3"
        :text="status.value"
        :color="status.color"
        :data-e2e="TimeEntryCypressAttribute.views.TIME_ENTRY_ROW_STATUS"
        size="is-size-7"
      />
    </div>
    <div class="is-flex is-align-items-center has-gap-15">
      <TimeEntryDescriptionTooltip
        :description="timeEntry.description"
        :is-ai-used="timeEntry.isAiUsed"
      />
      <p
        class="is-size-6 m-0 whitespace-no-wrap is-flex-shrink-0"
        :data-e2e="TimeEntryCypressAttribute.views.TIME_ENTRY_ROW_DURATION"
      >
        {{ timeEntry.durationFormatted }}
      </p>
    </div>
    <div
      v-if="!isReadOnly"
      class="is-flex is-full-height"
      @mouseover="setShouldShowActions(true)"
      @mouseleave="setShouldShowActions(false)"
      :data-e2e="TimeEntryCypressAttribute.views.TIME_ENTRY_ACTIONS_DIV"
    >
      <div class="is-flex is-justify-content-space-between is-align-items-center px-2">
        <i
          :class="`cls cls-pencil is-size-6 has-text-primary is-clickable mr-3 ${editIconVisibilityClass}`"
          @click="editTimeEntry(timeEntry)"
          :data-e2e="TimeEntryCypressAttribute.buttons.EDIT_TIME_ENTRY"
        />
        <i
          :class="`cls cls-trash is-size-6 has-text-danger is-clickable ${deleteIconVisibilityClass}`"
          @click="deleteTimeEntry(timeEntry)"
          :data-e2e="TimeEntryCypressAttribute.buttons.DELETE_TIME_ENTRY"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { TimeEntry } from '/@/modules/timeentry/models/TimeEntry';
import TimeEntryService from '/@/modules/timeentry/services/TimeEntryService';
import Status from '/@/modules/core/app/components/Status.vue';
import { EstateStatus } from '/@/modules/estate/constants/EstateStatus';
import ToastService from '/@/modules/core/ui/services/ToastService';
import Lang from '/@/modules/core/app/services/Lang';
import TimeEntryDescriptionTooltip from '@/modules/timeentry/components/presentational/TimeEntryDescriptionTooltip.vue';
import { TimeEntryCypressAttribute } from '/@/modules/timeentry/constants/TimeEntryCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TimeEntryRow',
  emits: ['on-delete', 'on-edit'],
  components: {
    Status,
    TimeEntryDescriptionTooltip
  },
  props: {
    timeEntry: { type: TimeEntry },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  static: {
    TimeEntryCypressAttribute
  },
  data() {
    return {
      shouldShowActions: false
    };
  },
  computed: {
    status() {
      return EstateStatus.getByKey(this.timeEntry.meta.status);
    },
    canDelete() {
      return !!this.timeEntry.policies?.canDelete.value;
    },
    canEdit() {
      return !!this.timeEntry.policies?.canEdit.value;
    },
    editIconVisibilityClass() {
      return this.shouldShowActions && this.canEdit
        ? 'is-visibility-visible'
        : 'is-visibility-hidden';
    },
    deleteIconVisibilityClass() {
      return this.shouldShowActions && this.canDelete
        ? 'is-visibility-visible'
        : 'is-visibility-hidden';
    }
  },
  methods: {
    deleteTimeEntry(timeEntry) {
      TimeEntryService.deleteEntity(timeEntry.id);
      ToastService.show(Lang.t(`${timeEntry.durationFormatted} entry deleted!`));
      this.$emit('on-delete', timeEntry.id);
    },
    editTimeEntry(timeEntry) {
      this.$emit('on-edit', timeEntry);
    },
    setShouldShowActions(value) {
      this.shouldShowActions = value;
    }
  }
};
</script>
